import React from 'react'
import PropTypes from 'prop-types'
import { CloseButton } from 'shared/UI/CloseButton'
import { getItemTypeConfig } from 'shared/Components/ItemContent/config'
import { triggerClickOnEnter, TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const Header = (props) => {

  const getActionButtons = () => {
    const itemConfig = getItemTypeConfig(props.item)

    return [
      {
        class: 'icon-new-tab',
        onClick: props.onOpenInNewTab,
        shouldDisplay: itemConfig.canOpenInNewTab
      }
    ]
  }

  return (
    <div className="preview-item-header">
      <h1>{props.title}</h1>
        <div className="action-buttons">
          { getActionButtons().map((action, i) => {
            return action.shouldDisplay && (
              <span
                key={i}
                className={action.class}
                onClick={action.onClick}
                onKeyDown={triggerClickOnEnter}
                style={action.style}
                tabIndex={TAB_INDEXES.Header}
                role="button" />
            )
            }
          )}
          <CloseButton onClose={props.onClose} />
        </div>
    </div>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  item: PropTypes.object.isRequired,
  onOpenInNewTab: PropTypes.func.isRequired
}

export default Header